import { render, staticRenderFns } from "./update-goods.vue?vue&type=template&id=cab9a932&scoped=true"
import script from "./update-goods.vue?vue&type=script&lang=js"
export * from "./update-goods.vue?vue&type=script&lang=js"
import style0 from "./update-goods.vue?vue&type=style&index=0&id=cab9a932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab9a932",
  null
  
)

export default component.exports